export const MARKETPLACE_SYNC_COLORS = {
  completed: { text: '#01A452', background: '#01A45214' },
  failed: { text: '#C62828', background: '#D32F2F14' },
  inProgress: { text: '#ED8822', background: '#FDF1D7' },
  unknown: { text: '#5F6978', background: '#E8EBF2' },
} as const;
